import { type ReactNode, useCallback, useMemo, useState } from 'react'

export const copyToClipboardPromise = async (value: any) => {
	return new Promise((resolve, reject) => {
		navigator.clipboard
			.writeText(value as string)
			.then(() => resolve(true))
			.catch(() => reject(false))
	})
}

export const useCopyClipboard = (timeout = 1000) => {
	const [isCopying, setIsCopying] = useState(false)
	const [isCopied, setIsCopied] = useState(false)

	const copyToClipboard = useCallback(
		(value: string | number | ReactNode) => {
			setIsCopying(true)

			return copyToClipboardPromise(value)
				.then(() => {
					setIsCopying(false)
					setIsCopied(true)
				})
				.catch(() => {
					setIsCopying(false)
					setIsCopied(false)
				})
				.finally(() => {
					setTimeout(() => {
						setIsCopied(false)
					}, timeout)
				})
		},
		[timeout],
	)

	return useMemo(
		() => ({
			copyToClipboard,
			isCopied,
			isCopying,
		}),
		[copyToClipboard, isCopied, isCopying],
	)
}
